import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';

const FilterPanel = ({ filters, onFilterChange, onClearFilters, isOpen, onClose, availableBrands = [] }) => {
  const [priceRange, setPriceRange] = useState(filters?.priceRange || [0, 500000]);

  useEffect(() => {
    setPriceRange(filters?.priceRange || [0, 500000]);
  }, [filters?.priceRange]);

  const handlePriceChange = (index, value) => {
    const newRange = [...priceRange];
    newRange[index] = parseInt(value) || 0;
    setPriceRange(newRange);
    onFilterChange('priceRange', newRange);
  };

  const handleBrandToggle = (brandName) => {
    const currentBrands = filters?.brands || [];
    const newBrands = currentBrands?.includes(brandName)
      ? currentBrands?.filter(name => name !== brandName)
      : [...currentBrands, brandName];
    onFilterChange('brands', newBrands);
  };

  const handleRatingChange = (rating) => {
    onFilterChange('minRating', filters?.minRating === rating ? null : rating);
  };

  const content = (
    <div className="bg-card rounded-xl md:rounded-2xl border border-border p-4 md:p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg md:text-xl font-semibold text-foreground">Filtreler</h3>
        <button
          onClick={onClose}
          className="lg:hidden w-8 h-8 flex items-center justify-center rounded-lg hover:bg-muted transition-colors"
          aria-label="Filtreleri kapat"
        >
          <Icon name="X" size={20} />
        </button>
      </div>

      <div className="space-y-6">
        <div>
          <h4 className="text-sm md:text-base font-semibold text-foreground mb-4">Fiyat Aralığı</h4>
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <input
                type="number"
                value={priceRange?.[0]}
                onChange={(e) => handlePriceChange(0, e?.target?.value)}
                className="w-full px-3 py-2 rounded-lg border border-border bg-background text-foreground text-sm"
                placeholder="Min"
              />
              <span className="text-muted-foreground">-</span>
              <input
                type="number"
                value={priceRange?.[1]}
                onChange={(e) => handlePriceChange(1, e?.target?.value)}
                className="w-full px-3 py-2 rounded-lg border border-border bg-background text-foreground text-sm"
                placeholder="Max"
              />
            </div>
            <div className="flex items-center justify-between text-xs text-muted-foreground">
              <span>₺{priceRange?.[0]?.toLocaleString('tr-TR')}</span>
              <span>₺{priceRange?.[1]?.toLocaleString('tr-TR')}</span>
            </div>
          </div>
        </div>

        {availableBrands?.length > 0 && (
          <div className="border-t border-border pt-6">
            <h4 className="text-sm md:text-base font-semibold text-foreground mb-4">Marka</h4>
            <div className="space-y-3">
              {availableBrands?.map((brand) => (
                <Checkbox
                  key={brand}
                  label={brand}
                  checked={filters?.brands?.includes(brand) || false}
                  onChange={() => handleBrandToggle(brand)}
                />
              ))}
            </div>
          </div>
        )}

        <div className="border-t border-border pt-6">
          <h4 className="text-sm md:text-base font-semibold text-foreground mb-4">Minimum Puan</h4>
          <div className="space-y-2">
            {[5, 4, 3, 2, 1]?.map((rating) => (
              <button
                key={rating}
                onClick={() => handleRatingChange(rating)}
                className={`
                  w-full flex items-center gap-2 px-3 py-2 rounded-lg
                  transition-colors
                  ${filters?.minRating === rating
                    ? 'bg-primary/10 border border-primary' :'hover:bg-muted border border-transparent'
                  }
                `}
              >
                <div className="flex items-center gap-1">
                  {[...Array(5)]?.map((_, index) => (
                    <Icon
                      key={index}
                      name="Star"
                      size={14}
                      color={index < rating ? 'var(--color-warning)' : 'var(--color-muted-foreground)'}
                      style={{ fill: index < rating ? 'var(--color-warning)' : 'none' }}
                    />
                  ))}
                </div>
                <span className="text-sm text-foreground">ve üzeri</span>
              </button>
            ))}
          </div>
        </div>

        <div className="border-t border-border pt-6">
          <Button
            variant="outline"
            fullWidth
            onClick={onClearFilters}
            iconName="X"
            iconPosition="left"
          >
            Filtreleri Temizle
          </Button>
        </div>
      </div>
    </div>
  );

  if (isOpen) {
    return (
      <>
        <div
          className="fixed inset-0 bg-background/80 backdrop-blur-sm z-40 lg:hidden"
          onClick={onClose}
        />
        <div className="fixed inset-y-0 left-0 w-80 bg-background z-50 overflow-y-auto lg:hidden p-4">
          {content}
        </div>
      </>
    );
  }

  return <div className="hidden lg:block">{content}</div>;
};

export default FilterPanel;